<script>

	import ArticleEntry from '@/components/ArticleEntry'
	import BlogishEntries from '@/components/BlogishEntries'
	import Logo from './Logo'
	import { head } from 'lodash'

	export default {
		routeConfig: {
			path: ':slug'
		},
		metaInfo () {
			return {
				title: (this.entry) ? this.entry.title : '',
				meta: [{
					property: 'og:image',
					content: (this.entry) ? this.entry.leadImage : ''
				}]
			}
		},
		data: () => ({
			entry: null
		}),
		computed: {
			slug () {
				return this.$route.params.slug
			}
		},
		render () {
			return (
				<BlogishEntries
					variables={{
						section: 'theDailySync'
					}}
					render={({ ready, entries }) => {
						if(!ready) {
							return null
						}
						if(this.slug === 'today') {
							this.entry = head(entries)
						} else {
							this.entry = this.entry = entries.find((entry) => entry.slug === this.slug)
						}
						if(!this.entry) {
							this.$router.push({ name: 'theDailySync', query: { statusCode: 404 } })
						}
						return (
							<ArticleEntry
								entry={this.entry}
								prehead={() => <Logo centered={true} class="theDailySyncLogo" />}
								byline={(entry) => (
									<div domPropsInnerHTML={entry.intro}></div>
								)}
							/>
						)
					}}
				/>
			)
		}
	}

</script>

<style lang="scss" scoped>

	.theDailySyncLogo {
		margin-bottom:1rem;
	}

</style>



// WEBPACK FOOTER //
// src/routes/the-daily-sync/entry.vue